import React from 'react';
import { Modal, Button, Form, Select } from 'antd';

import SelectPlaceHolder from "../../../components/SelectPlaceHolder";

export default class ImprimirModal extends React.Component {
    render() {
        return (
            <Modal
                title={"Imprimir Comprobante"}
                visible={this.props.visible}
                onCancel={this.props.onClose}
                destroyOnClose={true}
                style={{ top: 30 }}
                width={1200}
                footer={[
                    <Button
                        key="send"
                        type="primary"
                        onClick={this.props.onClose}
                    >
                        Ok
                    </Button>,
                <Button
                       key="print"
                       type="primary"
                       onClick={this.props.onDownload}
                   >
                       Descargar
                   </Button>
                ]}
            >
                <Form>
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.formValues.idFormato ?
                                        { key: this.props.formValues.idFormato } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Seleccione Formato" />}
                                onChange={(option) => this.props.onChange(option.key)}
                                optionFilterProp="children"
                            >
                                {this.props.formValues.formatos.map(item => (
                                    <Select.Option value={item.id} key={item.id}>{item.nombre}</Select.Option>
                                ))}
                            </Select>
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            <embed
                                src={this.props.formValues.file}
                                // src={this.props.formValues.file+ '#view=fitH'}
                                style={{ width: '100%', height: 450 }}
                                type="application/pdf"
                            />
                        </div>
                    </div>
                </Form>
            </Modal>
        );
    }
}